// extracted by mini-css-extract-plugin
export default {"copyright":"Image_copyright__JEbOd","image":"Image_image__bh20l","imageError":"Image_imageError__AG29h","source":"Image_source__XBPW0"};